import { render, staticRenderFns } from "./SavedWorklists.vue?vue&type=template&id=8656b35e&scoped=true"
import script from "./SavedWorklists.vue?vue&type=script&lang=js"
export * from "./SavedWorklists.vue?vue&type=script&lang=js"
import style0 from "./SavedWorklists.vue?vue&type=style&index=0&id=8656b35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8656b35e",
  null
  
)

export default component.exports